import Audio from '@/lib/audio.js';
import Cards from '@/lib/cards.js';
import { mountVueComponent } from '@/lib/mount-vue-component.js';
import VideoThumbnails from '@/lib/video-thumbnails.js';

const setupPrintButton = (id = 'printButton') => {
	const button = document.getElementById(id);
	if (button) {
		button.addEventListener('click', () => {
			window.print();
		});
	} else {
		console.warn(`Print button with id "${id}" not found.`);
	}
};

export default function () {
	setupPrintButton();

	const cards = new Cards();
	cards.setup('ul.cards', 'li', 'fitRows');

	const audio = new Audio();
	audio.setup('jp-jplayer');

	const videoThumbnails = new VideoThumbnails();
	videoThumbnails.setup('preview-container.video');

	import('@/lib/components/Video/VideoPlayer').then((videoPlayer) => {
		mountVueComponent('video-player', videoPlayer);
	});

	import('@/lib/components/Video/VideoModal.vue').then((videoModal) => {
		mountVueComponent('video-modal', videoModal);
	});

	/** Comments */
	import('@/lib/components/Comments/Comments.vue').then((comments) => {
		mountVueComponent('comments', comments);
	});

	import('@/lib/components/Shared/PdfViewer/PdfViewer.vue').then((pdfViewer) => {
		mountVueComponent('pdf-viewer', pdfViewer);
	});
}
